import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import Cargando from '../../utils/Cargando';
import { alertaGeneral } from '../../utils/alertas';
import apiClient from '../../utils/axiosPetition';

const PrescripcionDocumentsTable = ({ patientId, isDownload, documentos, loadingDocs = false, documentsInAppointment = false, onHandleClickDownload, onHandleClickView }) => {

    const [cargando, setCargando] = useState(true);
    const [documentosCopy, setDocumentosCopy] = useState(documentos);
    const [filtroDocumentos, setFiltroDocumentos] = useState('historia');
    const [incapacidades, setIncapacidades] = useState(null);
    const [medicamentos, setMedicamentos] = useState(null);
    const [examenesLaboratorio, setExamenesLaboratorio] = useState(null);
    const [ayudasDiagnosticas, setAyudasDiagnosticas] = useState(null);
    const [interconsultas, setInterconsultas] = useState(null);
    const [historiaClinica, setHistoriaClinica] = useState(null);
    const [apoyoTerapeutico, setApoyoTerapeutico] = useState(null);

    useEffect(() => {
        if (loadingDocs || (documentsInAppointment && documentos === undefined)) {
            setCargando(true);
            return;
        }
        if (documentos) {
            setDocumentosCopy(documentos);
            setIncapacidades(documentos.incapacidad);
            setMedicamentos(documentos.medicamentos);
            setExamenesLaboratorio(documentos.examenLaboratorio);
            setAyudasDiagnosticas(documentos.ayudasDiagnosticas);
            setInterconsultas(documentos.interconsulta);
            setApoyoTerapeutico(documentos.apoyoTerapeutico);
            setHistoriaClinica(documentos.historiaClinica);
        }
        setCargando(false);
    }, [documentos, loadingDocs, documentsInAppointment]);

    useEffect(() => {
        switch (filtroDocumentos) {
            case 'medicamentos':
                setDocumentosCopy(medicamentos && medicamentos);
                break;
            case 'incapacidad':
                setDocumentosCopy(incapacidades && incapacidades);
                break;
            case 'examenes':
                setDocumentosCopy(examenesLaboratorio && examenesLaboratorio);
                break;
            case 'ayudas':
                setDocumentosCopy(ayudasDiagnosticas && ayudasDiagnosticas);
                break;
            case 'interconsultas':
                setDocumentosCopy(interconsultas && interconsultas);
                break;
            case 'apoyo':
                setDocumentosCopy(apoyoTerapeutico && apoyoTerapeutico);
                break;
            case 'historia':
                setDocumentosCopy(historiaClinica && historiaClinica);
                break;
            case 'consentimiento':
                setDocumentosCopy(documentos.consentimiento && documentos.consentimiento);
                break;
            default:
                setDocumentosCopy(null);
                break;
        }
    }, [filtroDocumentos, medicamentos, incapacidades, examenesLaboratorio, ayudasDiagnosticas, interconsultas, apoyoTerapeutico, historiaClinica, documentos])

    const handleDownloadAllHistory = async () => {
        let closeLoading = null;
        try {
            closeLoading = alertaGeneral({
                titulo: 'Preparando archivo...',
                messageHtml: 'Por favor espera mientras generamos tu historia clínica.',
                isLoading: true,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false
            });
            const response = await apiClient.get(`/api/patient/historia-clinica/descargar-todo/${patientId}`, {
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'historia-clinica.zip');
            document.body.appendChild(link);
            link.click();
            link.remove();
            if (closeLoading && typeof closeLoading.close === 'function') closeLoading.close();
            alertaGeneral({
                titulo: '¡Descarga lista!',
                messageHtml: 'Tu historia clínica se ha descargado correctamente.'
            });
        } catch (error) {
            if (closeLoading && typeof closeLoading.close === 'function') closeLoading.close();
            alertaGeneral({
                titulo: 'Error',
                messageHtml: 'No se pudo descargar la historia clínica. Intenta de nuevo.',
                isError: true
            });
        }
    };

    if (cargando) {
        return (
            <Cargando message={"Cargando documentos..."}/>
        )
    }

    if (documentsInAppointment && documentos && Object.entries(documentos).length === 0) {
        return (
            <div className="bg-white p-6 ">
                <p className="bg-[#1f94c2ff] py-2 px-5 text-white text-xs md:text-sm font-medium rounded-md w-fit"> No hay documentos para mostrar </p>
            </div>
        )
    }

    return (
        <div className="bg-white border-l border-b border-r border-gray-300">
            {/* Contenedor scrollable con borde inferior */}
            <div className="relative mb-4">
                <div className="overflow-x-auto scrollbar-hide">
                    {/* Encabezado de pestañas */}
                    <div className="flex whitespace-wrap pb-2">
                        <button
                            className={`px-4 py-2 focus:outline-none ${filtroDocumentos === 'historia' ? 'border-b-2 border-blue-600' : ''}`}
                            onClick={() => setFiltroDocumentos('historia')}
                        >
                            Historias Clinicas
                        </button>
                        <button
                            className={`px-4 py-2 focus:outline-none ${filtroDocumentos === 'medicamentos' ? 'border-b-2 border-blue-600' : ''}`}
                            onClick={() => setFiltroDocumentos('medicamentos')}
                        >
                            Medicamentos
                        </button>
                        <button
                            className={`px-4 py-2 focus:outline-none ${filtroDocumentos === 'incapacidad' ? 'border-b-2 border-blue-600' : ''}`}
                            onClick={() => setFiltroDocumentos('incapacidad')}
                        >
                            Incapacidad
                        </button>
                        <button
                            className={`px-4 py-2 focus:outline-none ${filtroDocumentos === 'examenes' ? 'border-b-2 border-blue-600' : ''}`}
                            onClick={() => setFiltroDocumentos('examenes')}
                        >
                            Exámenes de Laboratorio
                        </button>
                        <button
                            className={`px-4 py-2 focus:outline-none ${filtroDocumentos === 'ayudas' ? 'border-b-2 border-blue-600' : ''}`}
                            onClick={() => setFiltroDocumentos('ayudas')}
                        >
                            Ayudas Diagnósticas
                        </button>
                        <button
                            className={`px-4 py-2 focus:outline-none ${filtroDocumentos === 'interconsultas' ? 'border-b-2 border-blue-600' : ''}`}
                            onClick={() => setFiltroDocumentos('interconsultas')}
                        >
                            Interconsulta
                        </button>
                        <button
                            className={`px-4 py-2 focus:outline-none ${filtroDocumentos === 'apoyo' ? 'border-b-2 border-blue-600' : ''}`}
                            onClick={() => setFiltroDocumentos('apoyo')}
                        >
                            Apoyo Terapéutico
                        </button>
                        <button
                            className={`px-4 py-2 focus:outline-none ${filtroDocumentos === 'consentimiento' ? 'border-b-2 border-blue-600' : ''}`}
                            onClick={() => setFiltroDocumentos('consentimiento')}
                        >
                            Consentimiento
                        </button>
                    </div>
                    {/* Botón solo para historia clínica */}
                    {filtroDocumentos === 'historia' && historiaClinica && historiaClinica.length > 0 && (
                        <button
                            className="button-send mb-2 ml-2"
                            onClick={handleDownloadAllHistory}
                        >
                            Descargar toda mi historia clínica
                        </button>
                    )}
                </div>
                {/* Borde inferior que se extiende completamente */}
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gray-300" />
            </div>
            <div className="overflow-x-auto max-w-full overflow-y h-[300px] p-2">
                {(documentosCopy && documentosCopy.length > 0) ?
                    <div className="inline-block min-w-full max-w-screen-lg">
                        <table className="min-w-full divide-y border border-gray-300 divide-gray-300 border-collapse rounden-lg">
                            <thead className="bg-gray-200 text-center">
                                <tr>
                                    <th scope="col" className="px-6 py-3 text-sm font-medium text-gray-900 uppercase tracking-wider">
                                        Fecha Asignación {filtroDocumentos}
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-sm font-medium text-gray-900 uppercase tracking-wider">
                                        {patientId || documentsInAppointment ? 'Doctor Encargado' : 'Paciente'}
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-sm font-medium text-gray-900 uppercase tracking-wider">
                                        Acciones
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-300">
                                {documentosCopy && documentosCopy.map((documento, index) => (
                                    <tr key={index} className="divide-x divide-darkgray-200">
                                        <td className="px-4 py-2">
                                            <p className="text-sm text-wrap text-center font-medium text-gray-500">
                                                {moment(documento.createdAt).tz('America/Bogota').format('DD/MM/YYYY')}
                                            </p>
                                        </td>
                                        <td className="px-4 py-2">
                                            <p className="text-sm text-wrap text-center font-medium text-gray-500">
                                                {patientId || documentsInAppointment ? documento?.doctorId?.fullName : documento?.patientId?.fullName}
                                            </p>
                                        </td>
                                        <td className="px-4 py-2">
                                            <div className="flex flex-col md:flex-row items-center justify-center space-x-0 md:space-x-2 space-y-2 md:space-y-0">
                                                <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 w-full md:w-auto rounded" onClick={() => onHandleClickView(documento.url)}> Ver </button>
                                                {isDownload &&
                                                    <button className="bg-blue-900 hover:bg-blue-700 text-white font-bold py-1 px-2 w-full md:w-auto rounded"
                                                        onClick={() => onHandleClickDownload(documento.url, `${filtroDocumentos + moment(documento.createdAt).tz('America/Bogota') + documento?.patientId?.fullName || documento?.doctorId?.fullName}`)}
                                                    >
                                                        Descargar
                                                    </button>
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    :
                    <h1 className="text-center mb-4 text-gray-500"> <b> No hay {filtroDocumentos} para mostrar </b> </h1>
                }
            </div>
        </div>
    )
}

export default PrescripcionDocumentsTable;